VLW.controllers.NosVins = class extends VLW.controllers.Home {
	
	introContent(delay = 0) {
		let tl = new TimelineMax();
		tl.to(this.mainElementJS,.5, {opacity: 1});
		return true;
	}
	
	reload(){
		this.mainElementJS.dataset.mode  = (site.currentPathname.match(/carte$/))?"carte":"liste";
	}
	
	
	
	loadPIXIResources() {
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		_loader.load((loader, resources) => {
			this.pixi.resources = resources;
			loader.destroy()
		});
	}
};